export const MIN_ITEM_WIDTH = 20;
export const MIN_WIDTH_TO_SHOW_DATES = 96;
export const MIN_WIDTH_TO_SHOW_TAIL_DATE = 40;
// Right inset matching the WeekHeader pill's pr-2 so items align with their date pill.
export const ITEM_RIGHT_INSET = 8;
export const ITEM_LANE_HEIGHT = 68;
export const ITEM_LANE_HEIGHT_COMPACT = 40;
// Capsule height is uniform whether or not the item shows a badge/label.
export const ITEM_HEIGHT = 54;
export const ITEM_HEIGHT_COMPACT = 30;
export const ITEM_TOOLTIP_DELAY = 300;
// Per-depth indent for row header content. Applied after the selection checkbox
// so checkboxes stay aligned across depths while the rest of the row indents.
export const ROW_DEPTH_INDENT_PX = 16;
export const STALE_TIME_MS = 60 * 60 * 1000;
// Child lanes reserved while a parent's children load (one lane holding the
// side-by-side placeholder bars).
export const LOADING_CHILD_LANES = 1;
